import React, { useContext } from "react";
import { useEffectOnce } from "@lib-shared/hooks";
import { appSettings } from "core/config";
import { AppContext } from "core/context";
import { useUpdatePage } from "core/hooks";
import { axiosLogger, sessionManager } from "core/instances";
import { UrlUtils } from "core/lib";
import Notice from "components/notice";

function SignOut() {
    const appContext = useContext(AppContext);

    const pageTitle = "Sign Out";
    const [updateTitle,] = useUpdatePage();

    const location = window.location;
    const searchParams = new URLSearchParams(location.search);

    const redirectUrl = searchParams.get("returnUrl");

    const onLoad = async () => {
        updateTitle(pageTitle);

        let url = redirectUrl != null && redirectUrl.length > 0
            ? redirectUrl
            : appSettings.urls.homePage;

        url = UrlUtils.parseUrl(url);

        appContext.signOut();
        sessionManager.signOut(url);

        const isEnabled = appSettings.isEnabled;

        if (isEnabled.logAllResponsesToDatabase || isEnabled.logErrorsToDatabase) {
            axiosLogger.clear();
        }
    }

    useEffectOnce(() => {
        onLoad();
    });

    return (
        <Notice showSpinner={true}>
            <p>
                You have been signed out.
            </p>
        </Notice>
    );
}

export default SignOut;
